module.exports = __webpack_public_path__ + "img/chevron-down.b79f7d72.svg";